import React, { Component } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import BacktestService from "../../../service/backtest.service";
import UploadFileButton from "../../common/buttons/uploadFileButton";
import "./add.scss";

class Add extends Component {
  state = {
    symbol: "",
    weight: "",
    security: "",
    items: [],
    selectedItems: [],
    response: "",
    loading: false,
    error: false,
    xlsrow: [],
    xlscol: [],
    errorData: "",
    objItems: [],
    alternatives: false,
    autoCompleteData: [],
    displayAutoCompleteOp: false,
    ajax_in_progress: false,
  };

  onChangeHandler = (e) => {
    let value = e.target.value.toUpperCase();
    // this.setState({ [e.target.name]: value },() => this.getAutoCompleteData());

    if (e.target.name == "symbol") {
      this.setState(
        {
          [e.target.name]: value,
          displayAutoCompleteOp: true,
        },
        () => this.getAutoCompleteData()
      );
    } else {
      this.setState({
        [e.target.name]: value,
        displayAutoCompleteOp: false,
      });
    }
  };

  addItems = (e) => {
    e.preventDefault();
    if (!e.target.symbol.value || !e.target.weight.value) {
      return;
    }

    let autoCompleteData = this.state.autoCompleteData;
    let security = {};
    for (let i = 0; i < autoCompleteData.length; i++) {
      security[autoCompleteData[i]["symbol"]] =
        autoCompleteData[i]["fund_name"];
    }

    this.setState({
      symbol: "",
      weight: "",
      // security:security[this.state.symbol],
      items: [
        ...this.state.items,
        [this.state.symbol, this.state.weight, security[this.state.symbol]],
      ],
      autoCompleteData: [],
      security: "",
    });
  };
  testAPI = (e, callback) => {
    // var temp = {
    //   weights: {
    //     ACWI: "0.5",
    //     AGG: "0.5"
    //   }
    // };
    //    document.getElementById("compare_portfolios_form").submit();
    if (this.state.symbol && this.state.weight) {
      this.setState({
        symbol: "",
        weight: "",
        items: [...this.state.items, [this.state.symbol, this.state.weight]],
      });
    }
    let totalWeight = 0;
    let obj = {};
    this.state.items.forEach(function (d) {
      let num;
      if (d[1]) {
        num = d[1] / 100;
        totalWeight += num;
      }
      obj[d[0]] = num ? num.toFixed(2).toString() : null;
    });
    // deletes the empty key added
    delete obj[""];

    if (totalWeight !== 1) {
      console.log(
        "Total Weight does not add up to 1 : Value is " + totalWeight
      );
      document.getElementById("error-msgs").innerText =
        "Weights must add up to 100%.  Please try again.";
      document.getElementById("error-msgs").style.display = "block";
      return false;
    } else {
      document.getElementById("error-msgs").innerText = "";
      document.getElementById("error-msgs").style.display = "none";
    }
    var temp = {
      weights: obj,
      alternative: this.state.alternatives,
    };

    this.setState({
      loading: true,
    });
    let _user = window.localStorage.getItem("_user");

    if (_user) {
      _user = JSON.parse(_user);
    }

    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = () => {
      if (xmlHttp.readyState === 4) {
        if (xmlHttp.status === 200) {
          callback(xmlHttp.responseText);

          this.props.callbackFromParent(xmlHttp.responseText);

          // callback functions used to update items to parent page

          this.props.updateItems(this.state.items);

          // callback function used to navigate to next step
          this.props.navToNextPage();

          this.setState({
            loading: false,
          });
        } else {
          console.log("xmlHTTP.status = " + xmlHttp.status);
          this.setState({
            error: true,
            loading: false,
          });
        }
      }
    };
    xmlHttp.open(
      "post",
      "https://api.iqcioadvisers.com/ajax_compare_portfolio/"
    );
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.setRequestHeader("Authorization", "Bearer " + _user.token);
    xmlHttp.send(JSON.stringify(temp));
  };

  closeAllLists = (elmnt) => {
    /*close all autocomplete lists in the document,except the one passed as an argument:*/
    var x = document.getElementsByClassName("autocomplete-items");

    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i]) {
        /*     if (elmnt != x[i] && elmnt != inp) {*/
        x[i].parentNode.removeChild(x[i]);
      }
    }
  };

  removeSymbols = (e) => {
    var { items, selectedItems } = this.state;
    selectedItems.map((e) => items.splice(e, 1, null));
    items = items.filter((e) => e != null);
    this.setState({
      items,
    });
  };
  select = (e) => {
    let { selectedItems } = this.state;
    const { value } = e.target;
    if (selectedItems.indexOf(value) > -1) {
      selectedItems.splice(selectedItems.indexOf(value), 1);
    } else {
      selectedItems.push(value);
    }
    this.setState({ selectedItems });
  };

  // Xls fun

  xlsxEvent = (event) => {
    let file = event.target.files[0];
    console.log(file);
    if (file) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          let resRows = [];
          for (var i = 0; i < res.rows[0].length; i++) {
            resRows.push(res.rows[0][i].toLowerCase().trim());
          }
          if (
            res.rows.length > 0 &&
            resRows.includes("symbol") &&
            resRows.includes("weight")
          ) {
            let itemsRemoveFirst = res.rows.splice(1);

            this.setState({
              items: itemsRemoveFirst,
              xlsrow: res.rows,
              xlscol: res.cols,
              errorData: "",
            });
          } else {
            this.setState({
              errorData: "No symbol/weight in data",
              items: [],
            });
          }
        }
      });
    }
  };

  weightValueHandler = (e) => {
    let { name, value } = e.target;
    // let dataRow = e.target[e.target.selectedIndex].getAttribute("datarow")
    // console.log(e.target.dataRow)

    let items = this.state.items;

    let data = items.forEach(function (el) {
      if (el[0] === name) {
        el[1] = +value;
      }
    });

    this.setState({
      item: data,
    });
  };

  //   api call for autoComplete
  getAutoCompleteData = () => {
    let x = this.state.symbol;
    // let weight = this.state.weight;
    if (x.length >= 3) {
      if (!this.state.ajax_in_progress) {
        this.setState({
          ajax_in_progress: true,
        });
        BacktestService.getAutocomplete(`${x}`).then((res) => {
          this.setState({
            ajax_in_progress: false,
          });
          if (res) {
            this.setState({
              autoCompleteData: res,
            });
          }
        });
      }
    }
  };

  // suggestion handler
  suggestionHandler = (e) => {
    let symbol = e.target.getAttribute("symbol");
    let fund = e.target.getAttribute("fund");
    // clear list on selecting any option
    this.setState({
      symbol: symbol,
      // autoCompleteData:[],
      displayAutoCompleteOp: false,
      security: fund,
    });
  };
  alternativesHandler = () => {
    this.setState({
      alternatives: !this.state.alternatives,
    });
  };

  // event to remove options onClick else where
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    let { displayAutoCompleteOp } = this.state;
    if (displayAutoCompleteOp) {
      setTimeout(() => {
        this.setState({
          displayAutoCompleteOp: false,
        });
      }, 500);
    }
  };

  render() {
    const {
      loading,
      error,
      autoCompleteData,
      security,
      displayAutoCompleteOp,
    } = this.state;
    let suggestionsListComponent;
    if (autoCompleteData.length > 0 && displayAutoCompleteOp) {
      suggestionsListComponent = (
        <ul className="add_suggestion">
          {autoCompleteData.map((data, i) => (
            <li
              key={i}
              symbol={data["symbol"]}
              fund={data["fund_name"]}
              onClick={this.suggestionHandler}
            >{`${data["symbol"]} : ${data["fund_name"]}`}</li>
          ))}
        </ul>
      );
    }

    return (
      <div>
        <p id="compare_step1">
          Please enter the symbol and weight of your portfolio components that
          you would like to compare againt an IQCIO recommended model. You can
          either enter it in the table below or upload an excel sheet with a{" "}
          <b>symbol</b> column and the <b>weight</b> column
        </p>
        <div className="universe__table">
          <div className="universe__table-title subTxtRight">
            You could also upload excel sheet consisting of symbol and weight of
            your choice
          </div>

          <div className="inputFile">
            <span className="dataWarning">{this.state.errorData}</span>
            {/* <input
                type="file"
                id="input"
                onChange={this.xlsxEvent.bind(this)}
              /> */}
            <UploadFileButton
              text="Upload securities"
              icon="fa-upload"
              iconRight={false}
              eventHandler={(e) => {
                this.xlsxEvent(e);
              }}
            />
          </div>
          <div>
            <form onSubmit={this.addItems} id="compare_portfolios_form">
              <table className="table bordered tableCompare">
                <thead className="addTableHead">
                  <tr>
                    <th style={{ width: "40px" }} />
                    <th style={{ width: "400px" }}>Security</th>
                    <th>Symbol</th>
                    <th>Weight </th>
                    <th />
                  </tr>
                </thead>
                <tbody className="add-table">
                  <tr>
                    <td style={{ width: "40px" }}></td>
                    <td style={{ width: "400px" }}>{security}</td>
                    <td>
                      <input
                        id="compare_portfolio_symbol"
                        value={this.state.symbol}
                        onChange={this.onChangeHandler}
                        name="symbol"
                        placeholder="symbol"
                      />
                      {suggestionsListComponent}

                      {/* <AutoComplete
                        onChangeHandler={this.onChangeHandler}
                        onClickHandler={this.onClickHandler}
                        value={this.state.symbol}
                        // suggestions={[
                        //   "White",
                        //   "Black",
                        //   "Green",
                        //   "Blue",
                        //   "Yellow",
                        //   "Red"
                        // ]}
                        suggestions={autoCompleteData.map(data => data.symbol)}
                      /> */}
                    </td>
                    <td>
                      <input
                        id="compare_portfolio_weight"
                        value={this.state.weight}
                        onChange={this.onChangeHandler}
                        name="weight"
                        placeholder="weight"
                        type="number"
                        min="0"
                      />
                    </td>
                    <td>
                      <div>
                        <button className="btn addbnt">
                          <i className="fa fa-plus" /> Add row
                        </button>
                      </div>
                    </td>
                  </tr>
                  {this.state.items.map((item, i) => (
                    <tr key={i} data-row={i}>
                      <td style={{ width: "40px" }}>
                        <input
                          type="checkbox"
                          checked={
                            this.state.selectedItems.indexOf(i.toString()) > -1
                          }
                          value={i}
                          onChange={this.select}
                        />
                      </td>
                      <td data-col="2" style={{ width: "400px" }}>
                        {item[2]}
                      </td>
                      <td data-col="0">{item[0]}</td>
                      <td data-col="1">
                        <input
                          type="number"
                          defaultValue={item[1]}
                          name={item[0]}
                          onChange={this.weightValueHandler}
                          datarow={i}
                        />
                      </td>
                      <td />
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
                <div id="error-msgs">
                  Please check your input and try again.
                </div>
                <button className="btn" onClick={this.removeSymbols}>
                  <i className="fa fa-trash" aria-hidden="true" /> Remove
                </button>
                <button
                  className="btn btnSubmit"
                  type="button"
                  onClick={(e) => {
                    this.testAPI(e, (key) => {
                      this.state.response = parseInt(key);
                    });
                  }}
                  disabled={this.state.items.length === 0 ? true : false}
                >
                  {/* <i className="fa fa-paper-plane" id="compare_plane" /> <i className="fa fa-spinner fa-spin" id="compare_spinner" style={{display:"none"}}/> Submit */}
                  {loading && error == false && (
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ color: "#333333" }}
                    />
                  )}
                  {!loading && error == false && (
                    <i className="fa fa-paper-plane" />
                  )}
                  {!loading && error == false ? (
                    <span>&nbsp;Submit</span>
                  ) : loading && error == false ? (
                    <span>&nbsp;Loading</span>
                  ) : error && loading == false ? (
                    <span>Error</span>
                  ) : null}
                </button>
                <button className="btn alternative_cb">
                  <label>
                    <input
                      type="checkbox"
                      name="Include Alternative"
                      value={this.state.alternatives}
                      onChange={this.alternativesHandler}
                    />{" "}
                    Include Alternatives
                  </label>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/components/pages/compare/Add.jsx